// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"8c9d3689","933":"6d53525d"}[chunkId] + ".chunk.js";
};